import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { Field, FieldProps } from 'formik';
import React from 'react';
import { Translate } from 'react-localize-redux';
import FormItemLayout from './FormItemLayout';

const VoucherCanBeUsedFormField = () => {
  return (
    <Field name={'CanBeUsed'}>
      {({ field, form }: FieldProps) => {
        const onChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
          const { value } = event.target;

          if (value === 'on any order') {
            form.setFieldValue('IsValidOnlyOnce', false, false);
            form.setFieldValue('IsValidOncePerCustomer', false, false);
            form.setFieldValue('IsValidForFirstOrderOnly', false, false);
          }
          if (value === 'once only') {
            form.setFieldValue('IsValidOnlyOnce', true, false);
            form.setFieldValue('IsValidOncePerCustomer', false, false);
            form.setFieldValue('IsValidForFirstOrderOnly', false, false);
          }
          if (value === 'once per customer on their first order only') {
            form.setFieldValue('IsValidOnlyOnce', false, false);
            form.setFieldValue('IsValidOncePerCustomer', false, false);
            form.setFieldValue('IsValidForFirstOrderOnly', true, false);
          }
          if (value === 'once per customer') {
            form.setFieldValue('IsValidOnlyOnce', false, false);
            form.setFieldValue('IsValidOncePerCustomer', true, false);
            form.setFieldValue('IsValidForFirstOrderOnly', false, false);
          }

          field.onChange(event);
        };
        return (
          <FormItemLayout label={<Translate id="Voucher_order" />}>
            <Select
              {...field}
              onChange={onChange}
              disabled={form.isSubmitting}
              data-fd={'voucher-can-be-used'}
            >
              <MenuItem value={'on any order'}>
                <Translate id="On_any_order" />
              </MenuItem>

              <MenuItem value={'once only'}>
                <Translate id="Once_only" />
              </MenuItem>

              <MenuItem value={'once per customer on their first order only'}>
                <Translate id="Once_per_customer_on_their_first_order_only" />
              </MenuItem>

              <MenuItem value={'once per customer'}>
                <Translate id="Once_per_customer" />
              </MenuItem>
            </Select>
          </FormItemLayout>
        );
      }}
    </Field>
  );
};

export default VoucherCanBeUsedFormField;
